export const TRIBUNALEA_ACCESS_CATALOG_VERSION = 7;

export const SUITE_USER_ROLES = Object.freeze({
  CITIZEN: "citizen",
  LAWYER: "lawyer",
  EXPERT: "expert",
});

export const SUITE_USER_ROLE_LABELS = Object.freeze({
  [SUITE_USER_ROLES.CITIZEN]: "Ciudadano/a",
  [SUITE_USER_ROLES.LAWYER]: "Abogado/a",
  [SUITE_USER_ROLES.EXPERT]: "Perito/a",
});

export function normalizeSuiteUserRole(value) {
  return Object.values(SUITE_USER_ROLES).includes(value)
    ? value
    : SUITE_USER_ROLES.LAWYER;
}

export const APPLICATION_IDS = Object.freeze({
  PRAXIS: "praxis",
  INSTRUMENTA: "instrumenta",
  PERITIA: "peritia",
  CRITERIUM: "criterium",
  SCIENTIA: "scientia",
  CIVITA: "civita",
  LEXIA: "lexia",
  LAB: "lab",
});

export const TOOL_IDS = Object.freeze({
  PRAXIS_EXPEDIENTES: "praxis:expedientes",
  PRAXIS_FOLLOW_UPS: "praxis:follow_ups",
  PRAXIS_WORKFLOWS: "praxis:workflows",
  PRAXIS_DAILY_LISTS: "praxis:daily_lists",
  PRAXIS_WRITING: "praxis:writing",
  PRAXIS_NOTIFICATIONS: "praxis:notifications",
  PRAXIS_ADMINISTRATION: "praxis:administration",
  PRAXIS_INTEGRATIONS: "praxis:integrations",
  PRAXIS_ASSISTANT: "praxis:assistant",
  INSTRUMENTA_EXPEDIENTES: "instrumenta:expedientes",
  INSTRUMENTA_NORMS: "instrumenta:norms",
  INSTRUMENTA_JURISPRUDENCE: "instrumenta:jurisprudence",
  INSTRUMENTA_DOCTRINE: "instrumenta:doctrine",
  INSTRUMENTA_LIBRARY: "instrumenta:library",
  INSTRUMENTA_DOCUMENT_PROCESSOR: "instrumenta:document_processor",
  INSTRUMENTA_JUDICIAL_INTEREST: "instrumenta:judicial_interest",
  INSTRUMENTA_TAX_ID: "instrumenta:tax_id",
  INSTRUMENTA_PROFESSIONALS: "instrumenta:professionals",
  INSTRUMENTA_SENTENCES: "instrumenta:sentences",
  INSTRUMENTA_ASSISTANT: "instrumenta:assistant",
  LEXIA_STUDY: "lexia:study",
  CIVITA_UNDERSTAND_DOCUMENT: "civita:understand_document",
  CIVITA_RESOLVE_PROBLEM: "civita:prepare_claim",
  CIVITA_PREPARE_CLAIM: "civita:prepare_claim",
  CIVITA_ORGANIZE_EVENTS: "civita:organize_events",
  CIVITA_REVIEW_BEFORE_SIGNING: "civita:review_before_signing",
  CIVITA_FOLLOW_CASE: "civita:follow_case",
  CIVITA_PREPARE_CONVERSATION: "civita:prepare_conversation",
  CIVITA_VERIFY_LEGITIMACY: "civita:verify_legitimacy",
  CIVITA_FIND_LAWYER: "civita:find_lawyer",
  CIVITA_EXPLORE_OPTIONS: "civita:explore_options",
});

export const TRIBUNALEA_APPLICATIONS = Object.freeze([
  Object.freeze({ id: APPLICATION_IDS.PRAXIS, name: "Praxis" }),
  Object.freeze({ id: APPLICATION_IDS.INSTRUMENTA, name: "Instrumenta" }),
  Object.freeze({ id: APPLICATION_IDS.LEXIA, name: "Lexia" }),
  Object.freeze({ id: APPLICATION_IDS.PERITIA, name: "Peritia", comingSoon: true }),
  Object.freeze({ id: APPLICATION_IDS.CRITERIUM, name: "Criterium", comingSoon: true }),
  Object.freeze({ id: APPLICATION_IDS.SCIENTIA, name: "Scientia", comingSoon: true }),
  Object.freeze({ id: APPLICATION_IDS.CIVITA, name: "Civita" }),
  Object.freeze({ id: APPLICATION_IDS.LAB, name: "Lab", comingSoon: true }),
]);

export const TRIBUNALEA_TOOLS = Object.freeze([
  { id: TOOL_IDS.PRAXIS_EXPEDIENTES, applicationId: APPLICATION_IDS.PRAXIS, name: "Expedientes" },
  { id: TOOL_IDS.PRAXIS_FOLLOW_UPS, applicationId: APPLICATION_IDS.PRAXIS, name: "Seguimientos" },
  { id: TOOL_IDS.PRAXIS_WORKFLOWS, applicationId: APPLICATION_IDS.PRAXIS, name: "Flujos" },
  { id: TOOL_IDS.PRAXIS_DAILY_LISTS, applicationId: APPLICATION_IDS.PRAXIS, name: "Listas diarias" },
  { id: TOOL_IDS.PRAXIS_WRITING, applicationId: APPLICATION_IDS.PRAXIS, name: "Escritos" },
  { id: TOOL_IDS.PRAXIS_NOTIFICATIONS, applicationId: APPLICATION_IDS.PRAXIS, name: "Alertas" },
  { id: TOOL_IDS.PRAXIS_ADMINISTRATION, applicationId: APPLICATION_IDS.PRAXIS, name: "Administración" },
  { id: TOOL_IDS.PRAXIS_INTEGRATIONS, applicationId: APPLICATION_IDS.PRAXIS, name: "Integraciones" },
  { id: TOOL_IDS.PRAXIS_ASSISTANT, applicationId: APPLICATION_IDS.PRAXIS, name: "Justiniano en Praxis" },
  { id: TOOL_IDS.INSTRUMENTA_EXPEDIENTES, applicationId: APPLICATION_IDS.INSTRUMENTA, name: "Expedientes" },
  { id: TOOL_IDS.INSTRUMENTA_NORMS, applicationId: APPLICATION_IDS.INSTRUMENTA, name: "Normas" },
  { id: TOOL_IDS.INSTRUMENTA_JURISPRUDENCE, applicationId: APPLICATION_IDS.INSTRUMENTA, name: "Jurisprudencia" },
  { id: TOOL_IDS.INSTRUMENTA_DOCTRINE, applicationId: APPLICATION_IDS.INSTRUMENTA, name: "Doctrina" },
  { id: TOOL_IDS.INSTRUMENTA_LIBRARY, applicationId: APPLICATION_IDS.INSTRUMENTA, name: "Biblioteca IA" },
  { id: TOOL_IDS.INSTRUMENTA_DOCUMENT_PROCESSOR, applicationId: APPLICATION_IDS.INSTRUMENTA, name: "Procesador documental" },
  { id: TOOL_IDS.INSTRUMENTA_JUDICIAL_INTEREST, applicationId: APPLICATION_IDS.INSTRUMENTA, name: "Calculadora de Intereses" },
  { id: TOOL_IDS.INSTRUMENTA_TAX_ID, applicationId: APPLICATION_IDS.INSTRUMENTA, name: "Buscador de CUIT" },
  { id: TOOL_IDS.INSTRUMENTA_PROFESSIONALS, applicationId: APPLICATION_IDS.INSTRUMENTA, name: "Matrículas profesionales" },
  { id: TOOL_IDS.INSTRUMENTA_SENTENCES, applicationId: APPLICATION_IDS.INSTRUMENTA, name: "Sentencias" },
  { id: TOOL_IDS.INSTRUMENTA_ASSISTANT, applicationId: APPLICATION_IDS.INSTRUMENTA, name: "Justiniano en Instrumenta" },
  { id: TOOL_IDS.LEXIA_STUDY, applicationId: APPLICATION_IDS.LEXIA, name: "Estudiar con Justiniano" },
  { id: TOOL_IDS.CIVITA_UNDERSTAND_DOCUMENT, applicationId: APPLICATION_IDS.CIVITA, name: "Entender un documento" },
  { id: TOOL_IDS.CIVITA_RESOLVE_PROBLEM, applicationId: APPLICATION_IDS.CIVITA, name: "Resolver un problema" },
  { id: TOOL_IDS.CIVITA_REVIEW_BEFORE_SIGNING, applicationId: APPLICATION_IDS.CIVITA, name: "Revisar antes de firmar" },
  { id: TOOL_IDS.CIVITA_FOLLOW_CASE, applicationId: APPLICATION_IDS.CIVITA, name: "Seguir mi expediente" },
  { id: TOOL_IDS.CIVITA_PREPARE_CONVERSATION, applicationId: APPLICATION_IDS.CIVITA, name: "Preparar una conversación difícil" },
  { id: TOOL_IDS.CIVITA_VERIFY_LEGITIMACY, applicationId: APPLICATION_IDS.CIVITA, name: "Verificar si es legítimo" },
  { id: TOOL_IDS.CIVITA_FIND_LAWYER, applicationId: APPLICATION_IDS.CIVITA, name: "Encontrar un abogado" },
].map(Object.freeze));

export const TRIBUNALEA_APPLICATION_IDS = Object.freeze(
  TRIBUNALEA_APPLICATIONS.map(({ id }) => id),
);

export const TRIBUNALEA_TOOL_IDS = Object.freeze(
  TRIBUNALEA_TOOLS.map(({ id }) => id),
);

const toolApplicationIds = new Map(
  TRIBUNALEA_TOOLS.map(({ id, applicationId }) => [id, applicationId]),
);

export function applicationIdForTool(toolId) {
  return toolApplicationIds.get(toolId) || null;
}

export function createFullSuiteAccess(overrides = {}) {
  return {
    catalogVersion: TRIBUNALEA_ACCESS_CATALOG_VERSION,
    workspace: {
      id: null,
      type: "personal",
      organizationId: null,
      institutional: false,
      institutionalStatus: null,
      ...overrides.workspace,
    },
    applications: Object.fromEntries(
      TRIBUNALEA_APPLICATION_IDS.map((id) => [id, true]),
    ),
    tools: Object.fromEntries(
      TRIBUNALEA_TOOL_IDS.map((id) => [id, true]),
    ),
    ...Object.fromEntries(
      Object.entries(overrides).filter(([key]) => key !== "workspace"),
    ),
  };
}

export function canAccessApplication(access, applicationId) {
  return access?.applications?.[applicationId] !== false;
}

export function canAccessTool(access, toolId) {
  return access?.tools?.[toolId] !== false;
}
